import classnames from 'classnames/bind'
import Percent from '../../../icons/Percent';

import styles from './ConditionsPopupRedesign.module.scss'
import {toggleSignUp} from '../../../../helpers/loginActions';

const cx = classnames.bind(styles)

const OfferDetailsTab = ({ data }) => {
  const {
    content: { total, breakfast },
  } = data;

  const initRegistration = function (e) {
    e.preventDefault();
    toggleSignUp();
  }

  return (
    <div className={cx('offer-details')}>
      <div className={cx('head')}>
        <span className={cx('left')}>{total.title}</span>
        <span className={cx('right')}>{total.total}</span>
      </div>

      <div className={cx('container')}>
        {total.duration.map((item, i) => {
          return (
            <div className={cx('fl')} key={'duration' + i}>
              <span className={cx('left', 'gray')}>{item.value}</span>
              <span className={cx('right')}>{item.amount}</span>
            </div>
          );
        })}

        { total.description && (
          <div className={cx('club-title')}>
            <span className={cx('ico')} />
            { total.description?.club?.title}
          </div>
        )}

        { total.description && (
          <p className={cx('register-banner')} onClick={initRegistration}>
            <Percent className={cx('percent-icon')} />
            <span dangerouslySetInnerHTML={{__html: total.description?.value}} />
          </p>
        )}
      </div>

      <div className={cx('head')}>
        <span className={cx('left')}>{breakfast.title}</span>
        <span className={cx('right')}>{breakfast.total}</span>
      </div>

      {!!breakfast.duration.length && (
        <div className={cx('container')}>
          {breakfast.duration.map((item, i) => (
            <div className={cx('fl', 'duration')} key={'breakfast' + i}>
              <span className={cx('left', 'gray')}>{item.value}</span>
              <span className={cx('right')}>{item.amount}</span>
            </div>
          ))}
          {breakfast.meal_description && <p className={cx('meal-desc')}>{breakfast.meal_description}</p>}
        </div>
      )}

      <div className={cx('container')}>
        {breakfast.tax.included && (
          <div className={cx('tax')}>
            <h5 className={cx('tax-head')}>{breakfast.tax.included.label}</h5>
            {breakfast.tax.included.value.map((item, i) => (
              <p key={'tax-included' + i}>{item}</p>
            ))}
          </div>
        )}

        {breakfast.tax.not_included && (
          <div className={cx('tax')}>
            <h5 className={cx('tax-head')}>{breakfast.tax.not_included.label}</h5>
            {breakfast.tax.not_included.value.map((item, i) => (
              <p key={'tax' + i}>{item}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferDetailsTab
